// src/utils/authUtils.js
import { jwtDecode } from 'jwt-decode';

export const isTokenExpired = (token) => {
  if (!token) return true;
  try {
    const decoded = jwtDecode(token);
    return decoded.exp * 1000 < Date.now();
  } catch {
    return true;
  }
};

export const getDecodedToken = (token) => {
  try {
    return jwtDecode(token);
  } catch {
    return null;
  }
};
